import { CdkMenuModule, CdkMenuTrigger } from '@angular/cdk/menu';
import { CommonModule } from '@angular/common';
import {
  afterNextRender,
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  inject,
  signal,
  ViewChild,
} from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { CategoryDto, CategoryService, UserService } from '@api-client';
import { ModalService, ToastService } from '@front-share';
import { LepiIcon } from '@lepisode-ui/components';
import { CookieService } from 'ngx-cookie-service';
import { debounceTime, fromEvent, startWith, Subscription } from 'rxjs';
import { AutoAnimateDirective } from '../../../animations/auto-animate.directive';
import { ButtonComponent } from '../../../components/button/button.component';
import { UserAuthStore } from '../../../stores/user.store';
import SignUpPage from '../../auth/sing-up/sign-up.page';
import { SideMenuComponent } from '../side-menu/side-menu.component';

export type Menu = {
  title: string;
  link?: string;
};

export type DropDownMenu = {
  title: string;
  children?: Menu[];
};

export const subMenuList = [
  { key: 'my-page/history', value: '예약내역' },
  { key: 'magazine', value: '매거진' },
];

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    ButtonComponent,
    LepiIcon,
    CdkMenuModule,
    AutoAnimateDirective,
  ],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
})
export class HeaderComponent implements AfterViewInit {
  @ViewChild('dropdown') dropdown?: ElementRef<HTMLElement>;
  @ViewChild(CdkMenuTrigger) menuTrigger!: CdkMenuTrigger;

  userAuthStore = inject(UserAuthStore);
  modalService = inject(ModalService);
  router = inject(Router);
  toastService = inject(ToastService);
  cdr = inject(ChangeDetectorRef);
  cookieService = inject(CookieService);
  userService = inject(UserService);
  categoryService = inject(CategoryService);
  route = inject(ActivatedRoute);
  headerCategory = signal<string | null>(null);

  isOpen = signal<boolean>(false);
  dropdownHeight = signal<string>('');
  isMobile = signal<boolean>(false);
  subMenuList = signal(subMenuList);
  routerSubscription: Subscription | null = null;
  user = this.userAuthStore.user;

  topLevelCategoryList = toSignal(
    this.categoryService.categoryControllerFindAllTree()?.pipe(startWith([])),
  );

  constructor() {
    afterNextRender(() => {
      fromEvent(window, 'resize')
        .pipe(debounceTime(100))
        .subscribe(() => {
          this.dropdownHeight.set(
            `${this.dropdown?.nativeElement.scrollHeight}px`,
          );
          this.isOpen.set(false);
          this.cdr.detectChanges();
        });
    });
    this.route.queryParamMap.subscribe((params) => {
      const param = params.get('category');
      this.headerCategory.set(param);
    });
  }

  async handleSignUp() {
    if (this.isMobile()) {
      this.modalService.create(SignUpPage);
    } else {
      this.router.navigateByUrl('/sign-up', {
        replaceUrl: true,
      });
    }
  }

  async sidebar() {
    this.modalService.create(SideMenuComponent);
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.dropdownHeight.set(`${this.dropdown?.nativeElement.scrollHeight}px`);
    }, 100);
  }

  close() {
    this.isOpen.set(false);
  }

  logout() {
    this.userService.userControllerLogout().subscribe({
      next: () => {
        this.userAuthStore.setUser(null);
        this.toastService.success('로그아웃 되었습니다.');
        this.router.navigate(['/'], { replaceUrl: true });
      },
    });
  }

  async dismiss() {
    this.menuTrigger.close();
  }

  moveTo(category: CategoryDto) {
    this.router.navigate(['/product'], {
      queryParams: {
        category: category?.id,
      },
    });
  }
}
